import * as React from 'react';
import { Button, Input, Modal } from '@ixicare/ui';
import { PlaneEntryProps } from '@ixicare/resources';
import { t } from '~i18n';
import { Spacer } from '~components/Utils/Spacer';
import { getFieldError } from '~utils/error';
import { useMutation } from '@tanstack/react-query';
import SiteStore from '~modules/sites/store/Site';

export function ChangeFloorNameModal({
  onClose,
  onRefresh,
  floor,
  site,
}: {
  onClose: () => void;
  onRefresh: () => void;
  floor: PlaneEntryProps;
  site: SiteStore;
}) {
  const floorName = floor.floorName;
  const [description, setDescription] = React.useState(floorName ?? '');

  const updateMutation = useMutation({
    mutationFn: () => updateName(site, description, floor.id, floor.floor),
    onSuccess: () => {
      onRefresh();
      onClose();
    },
  });

  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-10">{t('siteSettings.floors.update.title')}</h3>
      <Spacer size={32} />
      <Input
        label={t('siteSettings.floors.table.name')}
        value={description}
        onValueChange={(x) => {
          setDescription(x);
        }}
        error={getFieldError('description')}
      />
      <Spacer size={32} />
      <div>
        <Button
          className="mb-15 error"
          isBlock
          buttonType="primary"
          type="button"
          onClick={() => updateMutation.mutate()}
        >
          {t('device.form.confirm')}
        </Button>
        <Button onClick={() => onClose()} isBlock buttonType="link">
          {t('global.cancel')}
        </Button>
      </div>
    </Modal>
  );
}

const updateName = async (site: SiteStore, floorName: string, floorId: number, floorNumber: number) => {
  const body = {
    floorName: floorName,
    floorNumber: floorNumber,
  };
  await site.updatePlane(floorId, body);
};
